import React, { useMemo } from 'react';
import cn from 'classnames';

import { hrLight } from '@edu-frontend/modules/src/components/ui/Theme';
import { ThemeProvider } from '@edu-frontend/modules/src/shared/lib/ThemeProvider';

import { ConditionallyWrapped } from '../../conditionally-wrapped/conditionally-wrapped';
import { MarkdownExtXContent } from '../../markdown/markdown';
import { useCodingPropsSelector } from '../context';
import { useMobileCodeEditorAvailability } from '../../../utils/hooks';
import { useMe } from '../../../utils/hooks/useMe';

import { CodingProblem__Disclaimer } from './__disclaimer/__disclaimer';
import { useDisclaimer } from './__disclaimer/useDisclaimer';
import { InfoPastesLoadable } from './coding-problem__info-pastes-loadable';

// @ts-ignore
import styles from './coding-problem__info.module.scss';

function Info() {
    const isTeacher = useMe('is_teacher');

    const problem = useCodingPropsSelector((p) => p.problem);

    const shouldShowNewMobileEditor = useMobileCodeEditorAvailability(problem);

    const Explainable = useCodingPropsSelector((p) => p.Explainable);
    const mdState = useMemo(
        () => ({
            resources: problem.resources || {},
        }),
        [problem.resources]
    );

    const { scrollBlockRef, showDisclaimer, shouldPinToContent } = useDisclaimer();

    return (
        <ConditionallyWrapped _by_={Explainable}>
            <div
                className={cn(styles.info, { [styles.info_view_mobile]: shouldShowNewMobileEditor })}
                ref={scrollBlockRef}
            >
                <h3 className={styles.instruction}>{problem.markup.instruction}</h3>
                <MarkdownExtXContent mdState={mdState} mix={styles.description}>
                    {problem.markup.description}
                </MarkdownExtXContent>
                {isTeacher && (
                    <ThemeProvider isRoot={false} theme={hrLight}>
                        <InfoPastesLoadable />
                    </ThemeProvider>
                )}
                {showDisclaimer && (
                    <CodingProblem__Disclaimer
                        className={cn(styles.disclaimer, shouldPinToContent && styles.disclaimer_pinToContent)}
                    />
                )}
            </div>
        </ConditionallyWrapped>
    );
}

export const CodingInfo = React.memo(Info);
